import Instrument from './Instrument';
import InstrumentRackBranch from './InstrumentRackBranch';
class InstrumentRack extends Instrument {
    constructor() {
        super(...arguments);
        this.branches = [];
    }
    chain(index) {
        if (!(this.branches[index] instanceof InstrumentRackBranch)) {
            const branch = new InstrumentRackBranch();
            branch.output().connect(this.output());
            this.branches[index] = branch;
        }
        return this.branches[index];
    }
    triggerAttack(note, time, velocity) {
        for (const branch of this.branches) {
            branch.triggerAttack.call(branch, note, time, velocity);
        }
    }
    triggerRelease(time, note) {
        for (const branch of this.branches) {
            branch.triggerRelease.call(branch, time, note);
        }
    }
}
export default InstrumentRack;
//# sourceMappingURL=InstrumentRack.js.map